// extracted by mini-css-extract-plugin
export var lg = "_4l-4";
export var md = "_4l-3";
export var sm = "_4l-2";
export var xs = "_4l-1";
export var xxs = "_4l-0";